import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  isDateInPreviousPayCycle,
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import { DatacenterEmployeeBonusPercentColumnList } from '../../constants/MockData';
import _ from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import moment from 'moment';

// Component is used to configure Bonus percentage of Datacenter employees
class ConfigureDatacenterEmployeeBonusPercent extends React.Component {
  // Constructor is used to set initial state of component
  constructor(props) {
    super(props);
    this.state = {
      isInAddMode: false,
      configuration: [],
      selectedEditRowId: undefined,
      updateData: {
        employeeId: 0,
        multiplier: 0,
        bonus: 0,
        burdenRatePercent: 0,
        // type: '',
        applicableFrom: null,
        bonusConfigurationId: 0,
        minDate: getCurrentPayCycleStartDate()
      },
      DatacenterEmployeeBonusColumnList: _.clone(DatacenterEmployeeBonusPercentColumnList),
      isDelete: false,
      showWarningMessage: false,
      confirmMessage: '',
      employeeMasterData: [],
      DatacenterEmployeeBonusPercentData: []
    };
  }

  // Method is used to get API data before components are mounted
  componentDidMount() {
    this.getRequiredData();
  }

  // Get data from DB using APIs
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData,
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Users.GetDatacenterEmployeeBonusConfiguration,
        key: 'DatacenterEmployeeBonusPercentData'
      }
    ])
      .then(({ DatacenterEmployeeBonusPercentData, employeeMasterData }) => {
        this._asyncRequest = null;
        if (employeeMasterData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          employeeMasterData: employeeMasterData.data.filter(x => (x.marketId === 6 || x.marketId === 7 ||
            ((x.otherMarketId || '').split('|').indexOf((6 || '').toString()) !== -1) ||
            ((x.otherMarketId || '').split('|').indexOf((7 || '').toString()) !== -1))) || [],
          DatacenterEmployeeBonusPercentData: DatacenterEmployeeBonusPercentData.data || [],
          configuration: DatacenterEmployeeBonusPercentData.config || [],
          reloadTable: !this.state.reloadTable
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get Bonus data of Datacenter employees
  GetDatacenterEmployeeBonus = () => {
    apiRequest({
      url: API_URL.Users.GetDatacenterEmployeeBonusConfiguration
    }).then(({ data: response }) => {
      this.setState({
        DatacenterEmployeeBonusPercentData: response || []
      });
    });
  };

  // Handle Cancel action
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, DatacenterEmployeeBonusColumnList } = this.state;
    DatacenterEmployeeBonusColumnList.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ DatacenterEmployeeBonusColumnList }, this.forceUpdate());
    return IsValid;
  };

  // Check whether employee bonus record is exists
  isEmployeeBonusExists = () => {
    const { updateData, DatacenterEmployeeBonusPercentData } = this.state;
    const existingRecord = DatacenterEmployeeBonusPercentData.find(y => moment(y.applicableFrom)
      .format(DateFormat) === moment(updateData.applicableFrom).format(DateFormat) &&
      y.bonusConfigurationId !== updateData.bonusConfigurationId && y.employeeId === updateData.employeeId);
    if (existingRecord !== undefined) {
      const message = 'Applicable From: ' + moment(existingRecord.applicableFrom).format(DateFormat) + ' already exists for ' + existingRecord.preferredName + '. If you want to update any information please edit that particular record.';
      ShowToast(message, toastType.WARNING, 5000, 500);
      return true;
    }
    return false;
  }

  // Save updated record
  saveUpdatedRecord = () => {
    if (this.isEmployeeBonusExists() || !this.isValidForm()) { return false; } else {
      const newParam = this.state.updateData;
      const params = {
        employeeId: newParam.employeeId,
        multiplier: newParam.multiplier,
        // type: newParam.type,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        bonusConfigurationId: newParam.bonusConfigurationId,
        StatusId: 1
      };
      this.SaveDatacenterEmployeeBonusPercent(params);
    };
  }

  // Save Bonus Percent of Datacenter Employees
  SaveDatacenterEmployeeBonusPercent = (params) => {
    apiPost({
      url: API_URL.Users.UpdateDatacenterEmployeeBonusConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: ''
        }, () => this.GetDatacenterEmployeeBonus());
      } else {
        ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Check whether Edit icon is visible for record or not
  IsEditVisible = (cellInfo) => {
    if (isDateInPreviousPayCycle(moment(cellInfo.applicableFrom).format(DateFormat))) {
      return false;
    }
    return true;
  }

  // Edit Record
  EditRecord = (cellInfo) => {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      const DatacenterEmployeeBonusColumnList = _.cloneDeep(DatacenterEmployeeBonusPercentColumnList);
      DatacenterEmployeeBonusColumnList.forEach(x => {
        if (x.key === 'applicableFrom') {
          x.minDate = getCurrentPayCycleStartDate();
        }
      });
      cellInfo.minDate = getCurrentPayCycleStartDate();
      this.setState({
        selectedEditRowId: { key: 'bonusConfigurationId', value: cellInfo.bonusConfigurationId },
        isInAddMode: false,
        updateData: { ...cellInfo },
        DatacenterEmployeeBonusColumnList
      });
    }
  }

  // Render Edit/Save/Cancel action buttons based on conditions
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.bonusConfigurationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>{(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_EMPLOYEE_BONUS_PERCENT, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
            {(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_EMPLOYEE_BONUS_PERCENT, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
              <Tooltip title="Delete Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
      </>
    );
  };

  /**
 * delete record
 */
  deleteRecord(cellInfo) {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      this.setState({
        showWarningMessage: true,
        confirmMessage: 'Do you want to delete this record?',
        updateData: cellInfo
      });
    }
  };

  /**
 * handle dialog box click event
 * @param {*} e
 */
  onClickHandle(e) {
    if (e) {
      const newParam = this.state.updateData;
      const params = {
        employeeId: newParam.employeeId,
        multiplier: newParam.multiplier,
        // type: newParam.type,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        bonusConfigurationId: newParam.bonusConfigurationId,
        StatusId: 2
      };
      this.SaveDatacenterEmployeeBonusPercent(params);
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: ''
      });
    }
  }

  // Handle value change event
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { DatacenterEmployeeBonusColumnList, employeeMasterData } = this.state;
    const param = { ...this.state.updateData };
    if (fieldName === 'preferredName') {
      const valueOfEmployee = employeeMasterData.find((x) => x.employeeName === value);
      param.employeeId = (valueOfEmployee || {}).employeeId;
      param.preferredName = (valueOfEmployee || {}).employeeName;
    } else {
      param[fieldName] = value;
    }
    isGridFormValid(value, DatacenterEmployeeBonusColumnList.find(x => x.key === fieldName), param);

    this.setState({ updateData: param });
  };

  // Add new record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const DatacenterEmployeeBonusColumnList = _.cloneDeep(DatacenterEmployeeBonusPercentColumnList);
    DatacenterEmployeeBonusColumnList.forEach(x => {
      if (x.key === 'applicableFrom') {
        x.minDate = getCurrentPayCycleStartDate();
      }
    });

    const rowNew = {
      bonusConfigurationId: 0,
      employeeId: 0,
      multiplier: 0,
      bonus: 0,
      // type: '',
      burdenRatePercent: 0,
      applicableFrom: null,

      minDate: getCurrentPayCycleStartDate()
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'bonusConfigurationId', value: 0 }, updateData: rowNew, DatacenterEmployeeBonusColumnList, reloadTable: !this.state.reloadTable, });
  };

  // Render components based on conditions
  render() {
    const { employeeMasterData, configuration, DatacenterEmployeeBonusPercentData, isInAddMode, selectedEditRowId, updateData, DatacenterEmployeeBonusColumnList } = this.state;
    const EditSource = [];
    EditSource.push({
      key: 'employeeMasterData',
      data: employeeMasterData
    });
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => { this.onClickHandle(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Datacenter Employee Payroll Configuration
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(DatacenterEmployeeBonusColumnList, configuration, [])}
                  data={DatacenterEmployeeBonusPercentData}
                  config={DatacenterEmployeeBonusColumnList}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={selectedEditRowId}
                  isInAddMode={isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  isInline={true}
                  AddNewRecord={{ action: this.AddNewRecord, title: 'Add New Datacenter Employee Payroll', visible: IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_EMPLOYEE_BONUS_PERCENT, SECTIONS.ADD_EDIT) }}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}


export default ConfigureDatacenterEmployeeBonusPercent;